// AUTO-GENERATED SEED — review before trusting. Rename keys (index→list/detail),
// refine params, confirm caller flags, add opt-in response types.
import { defineAdminRoute } from './define-admin-route';

export const publicRoutes = {
  version: defineAdminRoute({
      path: '/api/public/version',
      params: {},
      // Declared, not bound (BL-1833 PR 4a): the QA deploy gate reads it signed out.
      methods: {
        GET: {
          grant: { none: 'public — the deployed commit SHA only, no user or tenant data' },
          tenant: { from: 'none', reason: 'public — no user or tenant data' },
        },
      },
      caller: 'public',
    }),
};
